export enum VenueMenuItemType {
  Treatment = 'treatment',
  TreatmentPackage = 'treatment_package',
}
